export const ROUTES = {
  LOGIN: '/',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  OTP: 'verify-otp',
  DASHBOARD: '/dashboard',
  REPORTS: '/reports',
  ROLE: '/roles',
  ROLE_ACTIVE: '/roles/active',
  APPEARANCE: '/appearance',
  APPEARANCE_BRANDING: '/appearance/branding',
  USERS: '/users',
  USERS_ACTIVE: '/users/active',
  /** @deprecated use ROUTES.USERS_CREATE */
  CREATE_USER: '/users/create',
  USERS_CREATE: '/users/create',
  USER_DETAILS: '/users/:id',
  USER_MAP_ROLE: '/users/:id/map-role',
  SUPPORT: '/support',
  SETTINGS: '/settings',
  AKASHIC_LANDING: '/akashic-landing',
  AKASHIC_ADP_PIPELINE: '/akashic-data-pipeline',
  COMING_SOON: '/coming-soon',
} as const

export type Route = (typeof ROUTES)[keyof typeof ROUTES]
